import React from "react"
import HeadlineWithFocus from "../components/HeadlineWithFocus"
import Obfuscate from "react-obfuscate"
import { FaEnvelopeO, FaTwitter, FaGithub, FaFacebook } from "react-icons/lib/fa/"
import Helmet from "react-helmet"

export default props => {
  return (
    <div className="c-content-box">
      <Helmet title="Contact me" />

      <HeadlineWithFocus>
        You can get in touch <span>anytime through</span>
      </HeadlineWithFocus>
      <ul className="c-contact-list">

        {/* EMAIL */}
        <li className="c-contact-list__item">
          <FaEnvelopeO />
          <Obfuscate email="jawford@mail.com" />
        </li>

        {/* GITHUB */}
        <li className="c-contact-list__item">
          <FaGithub />
          <a
            href="https://github.com/jawford"
            target="_blank"
            rel="noopener noreferrer"
          >
            jawford
          </a>
        </li>

        {/* Facebook */}
        <li className="c-contact-list__item">
          <FaFacebook />
          <a
            href="https://www.facebook.com/james.awford.5"
            target="_blank"
            rel="noopener noreferrer"
          >
            James Awford
          </a>
        </li>
      </ul>
      <h2
        className={`
        js-action-button-anchor
        c-content-box__subheadline 
        c-content-box__subheadline--with-button
      `}
      >
        Keep in mind...
      </h2>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/contact.jsx